var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex align-stretch flex-wrap fill-height align-self-auto"},[(true)?_c('v-row',{staticClass:"d-flex justify-center align-content-center"},[_c('h1',{staticClass:"text-center"},[_vm._v("  App Sinistros ")])]):_vm._e(),_vm._v(" "),(false)?_c('v-row',[_c('v-col',[_c('graficos')],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e502ac52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Comum/Home.vue
// module id = null
// module chunks = 